import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { DateUtils } from '@/utils/dateUtils';

import { useVigerendData } from './-utils/useVigerendData';

const searchSchema = z.object({
  datum: z.string().date().catch(DateUtils.formatForInput(new Date())),
});

/**
 * This route is only used to redirect to the first hoofdstuk
 * of the inhoud view.
 */
export const Route = createFileRoute('/$bedrijfLineageId/viewer/vigerend/')({
  validateSearch: searchSchema.parse,
  loaderDeps: ({ search }) => ({ datum: search.datum }),
  loader: async ({
    params: { bedrijfLineageId },
    context: { queryClient },
    deps: { datum },
  }) => {
    const vigerendData = await queryClient.ensureQueryData(
      useVigerendData.getOptions({ date: new Date(datum), bedrijfLineageId })
    );

    const firstHoofdstuk = vigerendData?.flatMap(
      ({ hoofdstukken }) => hoofdstukken
    )?.[0];

    if (!firstHoofdstuk) return;

    throw redirect({
      to: '/$bedrijfLineageId/viewer/vigerend/inhoud/$hoofdstukLineageId',
      params: {
        bedrijfLineageId,
        hoofdstukLineageId: firstHoofdstuk.data.Lineage,
      },
      search: { datum },
    });
  },
});
